var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "table-wrapper scrollable", class: _vm.name + "-table" },
    [
      _c(
        "vs-table",
        {
          staticClass: "table-content",
          attrs: {
            notSpacer: "",
            hoverFlat: "",
            pagination: "",
            maxItems: "20",
            data: _vm.gridData,
            noDataText: _vm.$t("dash.table.no.data"),
          },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function ({ data }) {
                return _vm._l(data, function (row, index) {
                  return _c(
                    "vs-tr",
                    {
                      key: row.id,
                      staticClass: "row",
                      class: {
                        disabled:
                          !_vm.checkLock(row.pages.network) ||
                          (!_vm.isUserPremiumActive &&
                            index != 0 &&
                            !_vm.isUserPartner),
                      },
                    },
                    [
                      _c(
                        "vs-td",
                        {
                          staticClass: "column pages",
                          attrs: { data: row.pages.name },
                        },
                        [
                          _c(
                            "Tooltip",
                            {
                              attrs: { text: row.pages.name, position: "top" },
                            },
                            [
                              _c("page-image-avatar", {
                                class: {
                                  disabled: !_vm.checkLock(row.pages.network),
                                },
                                attrs: { page: row.pages },
                              }),
                              _c("p", { staticClass: "page-name" }, [
                                _vm._v(_vm._s(row.pages.name)),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "bots-data" },
                        [
                          _vm._l(row.bots, function (bot) {
                            return _c(
                              "vs-tr",
                              {
                                key: bot.id,
                                staticClass: "column bots hoverFlat",
                                class: {
                                  disabled:
                                    !_vm.isUserPremiumActive &&
                                    index != 0 &&
                                    !_vm.isUserPartner,
                                },
                                attrs: { "data-qa": `list-bots-${bot.name}` },
                              },
                              [
                                _vm._l(_vm.columns[1], function (item, i) {
                                  return _c(
                                    "vs-td",
                                    {
                                      key: i,
                                      staticClass: "column",
                                      class: item,
                                    },
                                    [
                                      item === "topic"
                                        ? _c("p", [_vm._v(_vm._s(bot.service))])
                                        : item === "subtopic"
                                        ? _c("p", [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(
                                                  bot.category
                                                    ? bot.category.name
                                                    : ""
                                                ) +
                                                "\n              "
                                            ),
                                          ])
                                        : item === "source"
                                        ? _c("p", [
                                            _vm._v(
                                              _vm._s(
                                                (bot.category &&
                                                  bot.category.id) ||
                                                  (bot.flux && bot.flux.length)
                                                  ? bot.domain
                                                  : _vm.$t(
                                                      "dash.bot.sources.none"
                                                    )
                                              )
                                            ),
                                          ])
                                        : item === "frequency"
                                        ? _c("p", [
                                            bot.instant
                                              ? _c("span", [_vm._v("Instant")])
                                              : bot.frequency === 0
                                              ? _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "dash.bots.post_frequency_manual"
                                                      )
                                                    )
                                                  ),
                                                ])
                                              : _c("span", [
                                                  _vm._v(
                                                    _vm._s(bot.frequency) +
                                                      " min"
                                                  ),
                                                ]),
                                          ])
                                        : item === "name"
                                        ? _c("p", [_vm._v(_vm._s(bot.name))])
                                        : item === "status"
                                        ? _c(
                                            "p",
                                            [
                                              (bot.status == 0 &&
                                                !_vm.checkLock(
                                                  "source_choice"
                                                )) ||
                                              (!_vm.isUserPremiumActive &&
                                                index != 0 &&
                                                !_vm.isUserPartner)
                                                ? [
                                                    _c(
                                                      "Tooltip",
                                                      {
                                                        attrs: {
                                                          text: _vm.$t(
                                                            "dash.plan.change_to_get_features"
                                                          ),
                                                          position: "top",
                                                        },
                                                      },
                                                      [
                                                        _c("vs-avatar", {
                                                          attrs: {
                                                            color:
                                                              "transparent",
                                                            size: "18px",
                                                            src: require("../../assets/img/icon_stop.svg"),
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.goToPlan()
                                                            },
                                                          },
                                                        }),
                                                        _c("span", [
                                                          _vm._v(" "),
                                                        ]),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                : bot.page.network ===
                                                    "facebook" &&
                                                  bot.page.isGroup &&
                                                  row.pages.story_config &&
                                                  row.pages.story_config
                                                    .onlyConciergerie &&
                                                  !row.pages.story_config
                                                    .created
                                                ? [
                                                    _c(
                                                      "Tooltip",
                                                      {
                                                        attrs: {
                                                          text: _vm.$t(
                                                            "dash.bots.status_proxy"
                                                          ),
                                                          position: "top",
                                                        },
                                                      },
                                                      [
                                                        _c("vs-avatar", {
                                                          attrs: {
                                                            color:
                                                              "transparent",
                                                            size: "18px",
                                                            src: require("../../assets/img/icon_wait_proxy.svg"),
                                                          },
                                                        }),
                                                        _c("span", [
                                                          _vm._v(" "),
                                                        ]),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                : !!bot.status &&
                                                  row.pages
                                                    .instagram_username &&
                                                  (!row.pages.story_config ||
                                                    !row.pages.story_config
                                                      .created)
                                                ? [
                                                    _c(
                                                      "Tooltip",
                                                      {
                                                        attrs: {
                                                          text: _vm.$t(
                                                            "dash.bots.status_proxy"
                                                          ),
                                                          position: "top",
                                                        },
                                                      },
                                                      [
                                                        _c("vs-avatar", {
                                                          attrs: {
                                                            color:
                                                              "transparent",
                                                            size: "18px",
                                                            src: require("../../assets/img/icon_wait_proxy.svg"),
                                                          },
                                                        }),
                                                        _c("span", [
                                                          _vm._v(" "),
                                                        ]),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                : !!bot.status &&
                                                  bot.status == 1
                                                ? [
                                                    _c(
                                                      "Tooltip",
                                                      {
                                                        attrs: {
                                                          text:
                                                            _vm.$t(
                                                              "dash.bots.status_running"
                                                            ) +
                                                            (bot.page.network ==
                                                            "linkedin"
                                                              ? ` - ${_vm.$t(
                                                                  "dash.bots.next_refresh"
                                                                )} ${_vm.dateFromNow(
                                                                  bot.expires_at
                                                                )}`
                                                              : ""),
                                                          position: "top",
                                                        },
                                                      },
                                                      [
                                                        _c("vs-avatar", {
                                                          attrs: {
                                                            color:
                                                              "transparent",
                                                            size: "18px",
                                                            src: require("../../assets/img/icon_check_light.svg"),
                                                          },
                                                        }),
                                                        _c("span", [
                                                          _vm._v(" "),
                                                        ]),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                : !!bot.status &&
                                                  bot.status == 2
                                                ? [
                                                    _c(
                                                      "Tooltip",
                                                      {
                                                        attrs: {
                                                          text:
                                                            _vm.$t(
                                                              "dash.bots.status_near_expiration"
                                                            ) +
                                                            new Date(
                                                              bot.error_msg
                                                            ).toLocaleDateString(),
                                                          position: "top",
                                                        },
                                                      },
                                                      [
                                                        _c("vs-avatar", {
                                                          attrs: {
                                                            color:
                                                              "transparent",
                                                            size: "18px",
                                                            src: require("../../assets/img/icon_warn.svg"),
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.confirmRefresh(
                                                                row.pages
                                                              )
                                                            },
                                                          },
                                                        }),
                                                        _c("a", {
                                                          attrs: { href: "#" },
                                                          domProps: {
                                                            innerHTML: _vm._s(
                                                              _vm.$t(
                                                                "dash.pages.refreshLabel"
                                                              )
                                                            ),
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.confirmRefresh(
                                                                row.pages
                                                              )
                                                            },
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                : bot.status == 0 &&
                                                  bot.page.network == "linkedin"
                                                ? [
                                                    _c(
                                                      "Tooltip",
                                                      {
                                                        attrs: {
                                                          text: _vm.$t(
                                                            "dash.bots.status_expired"
                                                          ),
                                                          position: "top",
                                                        },
                                                      },
                                                      [
                                                        _c("vs-avatar", {
                                                          attrs: {
                                                            color:
                                                              "transparent",
                                                            size: "18px",
                                                            src: require("../../assets/img/icon_stop.svg"),
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.confirmRefresh(
                                                                row.pages
                                                              )
                                                            },
                                                          },
                                                        }),
                                                        _c("a", {
                                                          attrs: { href: "#" },
                                                          domProps: {
                                                            innerHTML: _vm._s(
                                                              _vm.$t(
                                                                "dash.pages.refreshLabel"
                                                              )
                                                            ),
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.confirmRefresh(
                                                                row.pages
                                                              )
                                                            },
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                : bot.status == 3
                                                ? [
                                                    _c(
                                                      "Tooltip",
                                                      {
                                                        attrs: {
                                                          text: _vm.$t(
                                                            bot.error_msg
                                                          ),
                                                          position: "top",
                                                        },
                                                      },
                                                      [
                                                        _c("vs-avatar", {
                                                          attrs: {
                                                            color:
                                                              "transparent",
                                                            size: "18px",
                                                            src: require("../../assets/img/icon_stop.svg"),
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.edit(
                                                                bot.id
                                                              )
                                                            },
                                                          },
                                                        }),
                                                        _c("span", [
                                                          _vm._v(" "),
                                                        ]),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                : bot.page.network ===
                                                    "facebook" &&
                                                  !bot.page.isGroup &&
                                                  row.pages.story_config &&
                                                  row.pages.story_config
                                                    .onlyConciergerie &&
                                                  !row.pages.story_config
                                                    .created
                                                ? [
                                                    _c(
                                                      "Tooltip",
                                                      {
                                                        attrs: {
                                                          text: _vm.$t(
                                                            "dash.bots.status_proxy"
                                                          ),
                                                          position: "top",
                                                        },
                                                      },
                                                      [
                                                        _c("vs-avatar", {
                                                          attrs: {
                                                            color:
                                                              "transparent",
                                                            size: "18px",
                                                            src: require("../../assets/img/icon_wait_proxy.svg"),
                                                          },
                                                        }),
                                                        _c("span", [
                                                          _vm._v(" "),
                                                        ]),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                : _vm.checkLock(
                                                    bot.page.network
                                                  )
                                                ? [
                                                    _c(
                                                      "Tooltip",
                                                      {
                                                        attrs: {
                                                          text: _vm.$t(
                                                            bot.error_msg
                                                          ),
                                                          position: "top",
                                                        },
                                                      },
                                                      [
                                                        _c("vs-avatar", {
                                                          attrs: {
                                                            color:
                                                              "transparent",
                                                            size: "18px",
                                                            src: require("../../assets/img/icon_stop.svg"),
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.confirmRefresh(
                                                                row.pages
                                                              )
                                                            },
                                                          },
                                                        }),
                                                        _c("a", {
                                                          attrs: { href: "#" },
                                                          domProps: {
                                                            innerHTML: _vm._s(
                                                              _vm.$t(
                                                                "dash.pages.refreshLabel"
                                                              )
                                                            ),
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.confirmRefresh(
                                                                row.pages
                                                              )
                                                            },
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                : [
                                                    _c("vs-avatar", {
                                                      staticStyle: {
                                                        cursor: "default",
                                                      },
                                                      attrs: {
                                                        color: "transparent",
                                                        size: "18px",
                                                        src: require("../../assets/img/icon_stop.svg"),
                                                      },
                                                    }),
                                                  ],
                                            ],
                                            2
                                          )
                                        : _vm._e(),
                                    ]
                                  )
                                }),
                                _c(
                                  "vs-td",
                                  { staticClass: "column actions" },
                                  [
                                    _c(
                                      "vs-button",
                                      {
                                        staticClass: "btn-large",
                                        attrs: {
                                          color: "#6a1f4c",
                                          "vs-type": "filled",
                                          size: "large",
                                          type: "submit",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.edit(bot.id)
                                          },
                                        },
                                      },
                                      [
                                        _c("p", [
                                          _vm._v(
                                            _vm._s(_vm.$t("dash.button.edit"))
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              2
                            )
                          }),
                          !row.bots.length
                            ? _c(
                                "vs-tr",
                                { staticClass: "column bots" },
                                [
                                  _c(
                                    "vs-td",
                                    { staticClass: "column actions no-bot" },
                                    [
                                      _c("p", [
                                        _vm._v(
                                          _vm._s(_vm.$t("dash.bots.nobot"))
                                        ),
                                      ]),
                                      _c(
                                        "vs-button",
                                        {
                                          staticClass: "btn-large",
                                          attrs: {
                                            color: "#6a1f4c",
                                            "vs-type": "filled",
                                            size: "large",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.create({
                                                page: row.pages.id,
                                              })
                                            },
                                          },
                                        },
                                        [
                                          _c("p", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("dash.button.create")
                                              )
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        2
                      ),
                    ],
                    1
                  )
                })
              },
            },
          ]),
        },
        [
          _c(
            "template",
            { slot: "thead" },
            [
              _c("vs-th", { staticClass: "column pages" }, [
                _c("p", [_vm._v(_vm._s(_vm.$t("dash.table.title.pages")))]),
              ]),
              _c("vs-th", { staticClass: "column name" }, [
                _c("p", [_vm._v(_vm._s(_vm.$t("dash.table.title.name")))]),
              ]),
              _c("vs-th", { staticClass: "column topic" }, [
                _c("p", [_vm._v(_vm._s(_vm.$t("dash.table.title.topic")))]),
              ]),
              _c("vs-th", { staticClass: "column subtopic" }, [
                _c("p", [_vm._v(_vm._s(_vm.$t("dash.table.title.subtopic")))]),
              ]),
              _c("vs-th", { staticClass: "column source" }, [
                _c("p", [_vm._v(_vm._s(_vm.$t("dash.table.title.source")))]),
              ]),
              _c("vs-th", { staticClass: "column frequency" }, [
                _c("p", [_vm._v(_vm._s(_vm.$t("dash.table.title.frequency")))]),
              ]),
              _c("vs-th", { staticClass: "column status" }, [
                _c("p", [_vm._v(_vm._s(_vm.$t("dash.table.title.status")))]),
              ]),
              _c("vs-th", { staticClass: "column actions" }, [
                _c("p", [_vm._v(_vm._s(_vm.$t("dash.table.title.actions")))]),
              ]),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }